export const styles = {
    backgrounds: [
        { className: "primary-bg-colour", colour: "#FA5C36" },
        { className: "secondary-bg-colour", colour: "#2D343B" },
        { className: "navbar-bg-colour", colour: "#2D343B" }
    ],
    text: [
        { className: "primary-text", colour: "#FFFFFF" },
        { className: "secondary-text", colour: "#FA5C36" }
    ],
    borders: [
        { className: "primary-border-colour", colour: "#FA5C36" },
    ]
};
